import React from "react";
import {
  FiCheckCircle,
  FiTrendingUp,
  FiLayers,
  FiRefreshCcw,
  FiDatabase,
  FiClipboard,
  FiZap,
  FiLink,
} from "react-icons/fi";
import { MdOutlineInsights } from "react-icons/md";
import AIAutomationTemplate from "./AIAutomationTemplate";

const AISalesAssistant = () => {
  const features = [
    {
      title: "AI Lead Qualification",
      description:
        "Score, prioritize, and route leads using behavioral, firmographic, and intent data enriched in real time.",
      icon: <FiCheckCircle />,
    },
    {
      title: "Sales Automation Flows",
      description:
        "Trigger contextual outreach across email, WhatsApp, and voice with adaptive copy that mirrors prospect intent.",
      icon: <FiRefreshCcw />,
    },
    {
      title: "Smart Recommendations",
      description:
        "Surface next-best actions, bundles, and objection handling scripts powered by predictive models.",
      icon: <MdOutlineInsights />,
    },
    {
      title: "Dynamic CRM Syncing",
      description:
        "Two-way syncing keeps Salesforce, HubSpot, and Pipedrive updated with AI notes, tasks, and probability shifts.",
      icon: <FiDatabase />,
    },
    {
      title: "Workflow Orchestration",
      description:
        "Align marketing-qualified and sales-qualified motion with automated task routing, reminders, and approvals.",
      icon: <FiLayers />,
    },
    {
      title: "Revenue Intelligence Dashboards",
      description:
        "Real-time dashboards track pipeline velocity, win rates, and rep performance with AI commentary.",
      icon: <FiTrendingUp />,
    },
  ];

  const steps = [
    {
      title: "Data Harmonization",
      description:
        "Connect CRMs, enrichment tools, and marketing platforms to create a unified revenue graph.",
    },
    {
      title: "Playbook Design",
      description:
        "Map ICPs, buyer journeys, and KPIs to AI-driven cadences, prompts, and guardrails.",
    },
    {
      title: "Automation Build",
      description:
        "Configure workflows, scoring models, and sequencing logic with human override options.",
    },
    {
      title: "Enablement & Scale",
      description:
        "Train teams, launch pilots, and iterate using analytics until automation becomes standard practice.",
    },
  ];

  const benefits = [
    "Accelerate lead response times to under five minutes",
    "Increase SDR productivity with AI-generated tasks and content",
    "Improve pipeline visibility through unified analytics",
    "Boost conversion with data-backed next actions",
    "Reduce manual CRM hygiene work by up to 70%",
    "Standardize best-practice playbooks across teams",
  ];

  const expertise = [
    "RevOps strategists experienced with PLG, enterprise, and channel motions",
    "Certified specialists across Salesforce, HubSpot, Dynamics, and Zoho",
    "Custom GPT-powered assistants for proposals, quotes, and objection handling",
    "Lead enrichment integrations with Clearbit, ZoomInfo, and Apollo",
    "Compliance-ready handling of PII and consent-based outreach",
    "Embedded enablement team for training, adoption, and governance",
  ];

  
   const image = [
    {
      side_image: "../assets/images/ai-automation/2.png",
    }

  ];

  const useCases = [
    {
      industry: "SaaS",
      title: "Product-Led Growth Booster",
      description:
        "AI assistant monitors product usage, qualifies PQLs, and alerts reps with play-ready signals.",
    },
    {
      industry: "Manufacturing",
      title: "Global Distributor Alignment",
      description:
        "Automation syncs inquiries, quotes, and deal progress between HQ CRM and regional partners.",
    },
    {
      industry: "Professional Services",
      title: "Proposal Acceleration",
      description:
        "Assistant drafts proposals, compiles case studies, and pushes tasks into PSA tools.",
    },
    {
      industry: "Retail",
      title: "Omnichannel Lead Capture",
      description:
        "Chat, form, and event leads are qualified instantly and routed to storefront or ecommerce teams.",
    },
  ];

  const reasons = [
    "Full-stack team covering RevOps, AI, and CRM engineering",
    "Reusable blueprints for outbound, inbound, and channel sales",
    "Transparent experimentation framework for A/B and multivariate tests",
    "Embedded security practices with role-based access and audit trails",
    "Continuous optimization using revenue intelligence analytics",
    "Flexible engagement models from sprints to managed services",
  ];

  return (
    <AIAutomationTemplate
      title="AI Sales Assistant"
      heroDescription="Equip your revenue teams with an intelligent copilot that qualifies leads, automates workflows, and surfaces insights exactly when reps need them."
      about={{
        heading: "About AI Sales Assistant Services",
        description:
          "We orchestrate AI-driven playbooks spanning lead capture, nurturing, and closing to ensure every touchpoint is timely, relevant, and measurable.",
      }}
      features={features}
      steps={steps}
      benefits={benefits}
      expertise={expertise}
      image={image}
      useCases={useCases}
      reasons={reasons}
      ctaLabel="Unlock Sales Automation"
      meta={{
        title: "AI Sales Assistant | Revenue Automation Experts | Ayanshtech",
        description:
          "Lead qualification, smart recommendations, and sales workflow automation with dynamic CRM syncing.",
        ogTitle: "AI Sales Assistant Solutions",
        ogDescription:
          "Automate sales motions with AI-driven lead qualification, recommendations, and CRM orchestration.",
        ogUrl: "http://ayanshtechnology.com/ai-sales-assistant",
        canonical: "http://ayanshtechnology.com/ai-sales-assistant",
      }}
    />
  );
};

export default AISalesAssistant;


